import { VisuallyHidden } from 'reakit';
import { Box } from '../../Box/Box';

import { useCalendarContext } from '../context';
import { getMonthDaysCount } from '../helpers';
import {
  SHORT_DAYS_NAMES,
  DAYS_NAMES,
  COUNT_IN_ROW,
  WEEKS_COUNT_IN_TABLE,
} from '../constants';
import { Week } from './Week/Week';

export function DaysCalendar() {
  const { currentDate, calendarId } = useCalendarContext();

  const originalDate = new Date(currentDate);
  const currentMonth = originalDate.getMonth();
  const currentYear = originalDate.getFullYear();
  const daysCount = getMonthDaysCount(originalDate);
  const firstWeekDayNative = new Date(currentYear, currentMonth, 1).getDay();
  // Нативный Date начинает отсчет дней недели с Воскресенья
  const firstWeekDay = firstWeekDayNative === 0 ? 6 : firstWeekDayNative - 1;

  let remainingDays = daysCount;
  let weeks = [];
  while (weeks.length < WEEKS_COUNT_IN_TABLE) {
    const startDay = daysCount - remainingDays + 1;
    const startWeekDay = startDay === 1 ? firstWeekDay : 0;
    weeks.push(
      <Week
        key={startDay}
        startWeekDay={startWeekDay}
        startDay={startDay}
        daysCount={daysCount}
      />
    );
    remainingDays -= COUNT_IN_ROW.days - startWeekDay;
  }

  return (
    <Box
      as="table"
      role="grid"
      aria-labelledby={calendarId}
      styles={{ borderCollapse: 'collapse' }}
    >
      <VisuallyHidden as="caption">Выберите день</VisuallyHidden>
      <Box as="thead">
        <Box as="tr">
          {SHORT_DAYS_NAMES.map((dayName, index) => (
            <Box
              key={dayName}
              as="th"
              scope="col"
              abbr={DAYS_NAMES[index]}
              aria-label={DAYS_NAMES[index]}
              color="calendarDayOfWeek"
              pb="calendarDayNamesPb"
              styles={{
                fontSize: 'fs-14',
                lineHeight: 'calendarBtnLineHeight',
                fontWeight: 'normal',
              }}
            >
              {dayName}
            </Box>
          ))}
        </Box>
      </Box>
      <Box as="tbody">{weeks}</Box>
    </Box>
  );
}
